var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bg-gray p-2 evaluate-proposal" }, [
    _vm.isEmailState
      ? _c(
          "div",
          { staticClass: "bg-white p-3" },
          [
            _c("section-title", {
              staticClass: "my-4",
              attrs: {
                "has-line": false,
                icon: "fas fa-bell",
                reverse: true,
                title: "Solicitud de Código de Acceso"
              }
            }),
            _c(
              "validation-observer",
              { ref: "evaluateProposal" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "row col-12 col-md-7" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 info mb-2" },
                                    [
                                      _vm._v(
                                        " Seleccione el representante dentro del Centro de Evaluación para solicitar el Código de Acceso. "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 mt-3 justify-content-center"
                                    },
                                    [
                                      _c("custom-drop-down", {
                                        staticClass: "w-100",
                                        attrs: {
                                          "custom-error-msg":
                                            "Favor seleccionar el representante dentro del centro de evaluación para solicitar código de acceso.",
                                          error: errors[0],
                                          fieldkey: "id",
                                          fieldname: "name",
                                          options: _vm.evaluationCenters,
                                          placeholder: "Seleccione"
                                        },
                                        model: {
                                          value: _vm.evaluationCenter,
                                          callback: function($$v) {
                                            _vm.evaluationCenter = $$v
                                          },
                                          expression: "evaluationCenter"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "row col-12 col-md-5 evaluate-proposal__actions-group"
                                },
                                [
                                  _c(
                                    "action-button",
                                    {
                                      staticClass:
                                        "evaluate-proposal__action mr-1 mr-md-4",
                                      attrs: {
                                        i: "fa fa-times-circle",
                                        variant: "outline-danger"
                                      },
                                      on: { click: _vm.onCancelHandler }
                                    },
                                    [_vm._v(" Cancelar ")]
                                  ),
                                  _c(
                                    "action-button",
                                    {
                                      staticClass: "evaluate-proposal__action",
                                      attrs: {
                                        i: "fas fa-chevron-circle-right",
                                        variant: "success"
                                      },
                                      on: { click: _vm.onAddHandler }
                                    },
                                    [_vm._v(" Continuar ")]
                                  )
                                ],
                                1
                              )
                            ])
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3152718223
                  )
                })
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm.isValidateState
      ? _c(
          "div",
          { staticClass: "bg-white p-3" },
          [
            _c("section-title", {
              staticClass: "my-4",
              attrs: {
                "has-line": false,
                icon: "fas fa-bell",
                reverse: true,
                title: "Solicitud de Código de Acceso"
              }
            }),
            _c(
              "validation-observer",
              { ref: "evaluateTokenProposal" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "row col-12 col-md-6" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 info mb-2" },
                                    [_vm._v("Ingresar Código de Acceso:")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "col-12" },
                                    [
                                      _c("custom-input", {
                                        attrs: {
                                          "custom-error-msg":
                                            "Favor ingresar código de acceso.",
                                          error: errors[0],
                                          placeholder: ""
                                        },
                                        model: {
                                          value: _vm.token,
                                          callback: function($$v) {
                                            _vm.token = $$v
                                          },
                                          expression: "token"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "row col-12 col-md-6 evaluate-proposal__actions-group"
                                },
                                [
                                  _c(
                                    "action-button",
                                    {
                                      staticClass:
                                        "evaluate-proposal__action mr-1 mr-md-4",
                                      attrs: {
                                        i: "fa fa-times-circle",
                                        variant: "outline-danger"
                                      },
                                      on: { click: _vm.onCancelHandler }
                                    },
                                    [_vm._v(" Cancelar ")]
                                  ),
                                  _c(
                                    "action-button",
                                    {
                                      staticClass: "evaluate-proposal__action",
                                      attrs: {
                                        i: "fas fa-chevron-circle-right",
                                        variant: "success"
                                      },
                                      on: { click: _vm.validationToken }
                                    },
                                    [_vm._v(" Continuar ")]
                                  )
                                ],
                                1
                              )
                            ])
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    1836181192
                  )
                })
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }